import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip"

// IMP-370: the three CTAs a landing page can record a click on.
const CTA_LABEL: Record<string, string> = {
  activate: "Activate",
  test_call: "Start test call",
  contact_us: "Contact us",
}

// IMP-370: a landing-page session's CTA clicks as a total count with a hover
// breakdown by CTA (e.g. "Activate ×2, Start test call ×1"). A session with no
// clicks shows a dash. Replaces the earlier badge-per-click rendering.
export function LandingPageCtaClicks({
  ctaCounts,
}: {
  ctaCounts: Record<string, number>
}) {
  const entries = Object.entries(ctaCounts).filter(([, n]) => n > 0)
  const total = entries.reduce((sum, [, n]) => sum + n, 0)

  if (total === 0) {
    return <span className="text-muted-foreground">—</span>
  }

  const breakdown = entries
    .map(([cta, n]) => `${CTA_LABEL[cta] ?? cta} ×${n}`)
    .join(", ")

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-default tabular-nums underline decoration-dotted underline-offset-2">
          {total}
        </span>
      </TooltipTrigger>
      <TooltipContent>{breakdown}</TooltipContent>
    </Tooltip>
  )
}
